import dayjs from "dayjs";

import { getPackageHref } from "app/common/hrefs";
import { ANNUAL_CAMPAIGN_CONFIG } from "app/components/AnnualPromoModal/configs/annualCampaignConfig";
import {
    ANNUAL_PROMOTION_FEATURE_DEFAULTS,
    isAnnualCampaignEligible,
} from "app/components/AnnualPromoModal/utils/campaignTypes";
import type { IDiscountCampaignConfig } from "app/components/discountCampaign/DiscountBanner/types/discountCampaignConfig";
import { GrowthbookService, TestsNames } from "app/services/trackingServices/GrowthBookService";

export const ANNUAL_CAMPAIGN_ID = "4 months upgrade";

export const buildAnnualCampaignConfig = (): IDiscountCampaignConfig => {
    const featureValue = GrowthbookService.growthbookInstance.getFeatureValue(
        TestsNames.ANNUAL_PROMOTION,
        ANNUAL_PROMOTION_FEATURE_DEFAULTS,
    );

    return {
        id: ANNUAL_CAMPAIGN_ID,
        bannerStorageKey: "annual.campaign.banner.last.shown",
        bannerTrackingPrefix: "Discount Banner",
        bannerCtaType: ANNUAL_CAMPAIGN_ID,
        getDiscountDateConfig: (subscriptionDateStart: string) => ({
            startDate: dayjs(subscriptionDateStart)
                .add(featureValue.minSubscriptionMonths, "month")
                .format("YYYY-MM-DD"),
            endDate: dayjs(subscriptionDateStart).add(featureValue.maxSubscriptionMonths, "month").format("YYYY-MM-DD"),
        }),
        isEligible: (swSettings, conditions) => {
            const isMarketingGreenLight = featureValue.isMarketingGreenlightEnabled
                ? !!conditions?.isMarketingGreenLight
                : true;
            return isAnnualCampaignEligible(swSettings, isMarketingGreenLight);
        },
        getBannerConfig: () => ANNUAL_CAMPAIGN_CONFIG.banner,
        getModalConfig: () => ANNUAL_CAMPAIGN_CONFIG.modal,
        getPromoCode: () => "",
        overrideCtaUrl: () => `${getPackageHref()}?withUpgradeToAnnual=true&isAnnualPromo`,
    };
};
